import { LanguageValue } from '../models/LanguageValue';

export const DEFAULT_EXPLOSION_PROTECTION: LanguageValue = {
    en: 'Safe Area',
    de: 'Safe Area',
    es: 'Safe Area',
    fr: 'Safe Area',
    it: 'Safe Area',
    cs: 'Safe Area',
    nl: 'Safe Area',
    pl: 'Safe Area',
    pt: 'Safe Area',
    tr: 'Safe Area',
    cn: 'Safe Area'
};
